import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

export default function LogiTalkLandingProductInfo() {
  const [currentHash, setCurrentHash] = useState("logiMall");
  const { t } = useTranslation();
  const howToUseIt = [
    {
      key: "logiMall",
      title: t("logiTalkLanding.productInfo.howToUseIt.freiscop.title"),
      desc: t("logiTalkLanding.productInfo.howToUseIt.freiscop.description"),
      img: "/img/logiMallMain.png",
      img_alt: t("logiTalkLanding.productInfo.howToUseIt.freiscop.imgAlt"),
      url: "https://freiscop.gbts.co.kr",
    },
    {
      key: "logiWork",
      title: t("logiTalkLanding.productInfo.howToUseIt.logiwork.title"),
      desc: t("logiTalkLanding.productInfo.howToUseIt.logiwork.description"),
      img: "/img/logiWork.png",
      img_alt: t("logiTalkLanding.productInfo.howToUseIt.logiwork.imgAlt"),
      url: "https://system.gbts.co.kr/",
    },
    {
      key: "logiKeep",
      title: t("logiTalkLanding.productInfo.howToUseIt.logikeep.title"),
      desc: t("logiTalkLanding.productInfo.howToUseIt.logikeep.description"),
      img: "/img/logiKeepMain.png",
      img_alt: t("logiTalkLanding.productInfo.howToUseIt.logikeep.imgAlt"),
      url: "https://freiscop.gbts.co.kr/storeMall",
    },
  ];

  function slidePrev() {
    let current = howToUseIt.findIndex((item) => item.key === currentHash);
    let prev = current - 1 > -1 ? current - 1 : howToUseIt.length - 1;
    let changedHash = howToUseIt[prev].key;
    setCurrentHash(changedHash);
  }

  function slideNext() {
    let current = howToUseIt.findIndex((item) => item.key === currentHash);
    let next = current + 1 < howToUseIt.length ? current + 1 : 0;
    let changedHash = howToUseIt[next].key;
    setCurrentHash(changedHash);
  }

  const CarouselItem = useCallback((props) => {
    return <CarouselItemRender {...props} />;
  }, []);

  const CarouselItemRender = React.memo((props) => {
    const { item } = props;
    return (
      <div
        className={`carousel-item ${currentHash === item.key ? "active" : ""}`}
        key={item.key}
      >
        <div className="h4 font-weight-bold mb-2">
          <span className="text-warning">{item.title}</span>
          <button
            className="btn btn-sm btn-outline-light py-0 font-weight-500 ml-2"
            style={{ fontSize: "0.4em" }}
            onClick={() => {
              window.open(item.url, "_blank", "width=1200, height=800");
            }}
          >
            {t("logiTalkLanding.productInfo.howToUseIt.goNow")}
            <i className="fa-solid fa-arrow-right-long ml-2" />
          </button>
        </div>
        <p className="h5 mb-4" style={{ lineHeight: "1.5em" }}>
          {item.desc}
        </p>
        <div className="d-flex flex-column justify-content-center align-items-center">
          <img
            className="shadow"
            src={item.img}
            style={{
              height: "auto",
              width: "100%",
              maxWidth: 400,
            }}
          />
          <p className="text-light mt-2">▲ {item.img_alt}</p>
        </div>
      </div>
    );
  });

  return (
    <div className="bg-white w-100 position-relative d-flex flex-row justify-content-center">
      <div className="row m-0 p-0" style={{ maxWidth: 1600 }}>
        <div className="col-12 col-xl-7 p-5 bg-white d-flex flex-column align-items-center">
          <div className="S-CORE mb-3">
            <p className="h2 m-0 mb-1 font-weight-bold">
              {t("logiTalkLanding.productInfo.productCards.title.1")}
            </p>
            <p
              className="h2 m-0 font-weight-bold"
              style={{ lineHeight: "1.5em" }}
            >
              <span className="bg-gbts text-white px-1 mr-1">
                {t("logiTalkLanding.logiTalk")}
              </span>{" "}
              {t("logiTalkLanding.productInfo.productCards.title.2")}
              <span
                className="text-dark px-1 ml-md-1"
                style={{ background: "#bb86fc" }}
              >
                <span className="d-inline-block position-relative text-white">
                  {t("logiTalkLanding.productInfo.productCards.title.3")}
                </span>
              </span>{" "}
              {t("logiTalkLanding.productInfo.productCards.title.4")}
            </p>
          </div>
          <div className="row m-0 p-0 px-md-4 w-100">
            <div className="col-md-6 m-0 p-0 py-2 px-md-2">
              <div className="shadow-sm border w-100 py-4 px-3 S-CORE h-100 rounded-lg">
                <div className="px-3">
                  <div className="h1 mb-1 text-freiscop">
                    <i className="fa-solid fa-rotate" />
                  </div>
                  <h3 className="m-0 mb-2 font-weight-bold">
                    {t(
                      "logiTalkLanding.productInfo.productCards.autoSynchro.title"
                    )}
                  </h3>
                </div>
                <div className="px-4">
                  <ul className="list-disc">
                    <li className="mb-1">
                      <p className="h6 mb-0 font-weight-400">
                        {t(
                          "logiTalkLanding.productInfo.productCards.autoSynchro.description.1"
                        )}
                      </p>
                    </li>
                    <li className="mb-1">
                      <p className="h6 mb-0 font-weight-400">
                        {t(
                          "logiTalkLanding.productInfo.productCards.autoSynchro.description.2"
                        )}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6 m-0 p-0 py-2 px-md-2">
              <div className="shadow-sm border w-100 py-4 px-3 S-CORE h-100 rounded-lg">
                <div className="px-3">
                  <div className="h1 mb-1 text-freiscop">
                    <i className="fa-solid fa-cloud-arrow-down" />
                  </div>
                  <h3 className="m-0 mb-2 font-weight-bold">
                    {t("logiTalkLanding.productInfo.productCards.save.title")}
                  </h3>
                </div>
                <div className="px-4">
                  <ul className="list-disc">
                    <li className="mb-1">
                      <p className="h6 mb-0 font-weight-400">
                        {t(
                          "logiTalkLanding.productInfo.productCards.save.description.1"
                        )}
                      </p>
                    </li>
                    <li className="mb-1">
                      <p className="h6 mb-0 font-weight-400">
                        {t(
                          "logiTalkLanding.productInfo.productCards.save.description.2"
                        )}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6 m-0 p-0 py-2 px-md-2">
              <div className="shadow-sm border w-100 py-4 px-3 S-CORE h-100 rounded-lg">
                <div className="px-3">
                  <div className="h1 mb-1 text-freiscop">
                    <i className="fa-brands fa-searchengin" />
                  </div>
                  <h3 className="m-0 mb-2 font-weight-bold">
                    {t(
                      "logiTalkLanding.productInfo.productCards.searchUser.title"
                    )}
                  </h3>
                </div>
                <div className="px-4">
                  <ul className="list-disc">
                    <li className="mb-1">
                      <p className="h6 mb-0 font-weight-400">
                        {t(
                          "logiTalkLanding.productInfo.productCards.searchUser.description.1"
                        )}
                      </p>
                    </li>
                    <li className="mb-1">
                      <p className="h6 mb-0 font-weight-400">
                        {t(
                          "logiTalkLanding.productInfo.productCards.searchUser.description.2"
                        )}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6 m-0 p-0 py-2 px-md-2">
              <div className="shadow-sm border w-100 py-4 px-3 S-CORE h-100 rounded-lg">
                <div className="px-3">
                  <div className="h1 mb-1 text-freiscop">
                    <i className="fa-solid fa-user-plus" />
                  </div>
                  <h3 className="m-0 mb-2 font-weight-bold">
                    {t(
                      "logiTalkLanding.productInfo.productCards.management.title"
                    )}
                  </h3>
                </div>
                <div className="px-4">
                  <ul className="list-disc">
                    <li className="mb-1">
                      <p className="h6 mb-0 font-weight-400">
                        {t(
                          "logiTalkLanding.productInfo.productCards.management.description.1"
                        )}
                      </p>
                    </li>
                    <li className="mb-1">
                      <p className="h6 mb-0 font-weight-400">
                        {t(
                          "logiTalkLanding.productInfo.productCards.management.description.2"
                        )}
                      </p>
                    </li>
                    <li className="mb-1">
                      <p className="h6 mb-0 font-weight-400">
                        {t(
                          "logiTalkLanding.productInfo.productCards.management.description.3"
                        )}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-xl-5 p-5 bg-gbts d-flex flex-column align-items-center">
          <div className="BM-DH d-flex flex-column align-items-center">
            <p
              className="h2 text-white mb-3"
              style={{ textShadow: "0px 5px 0px rgba(0,0,0,1)" }}
            >
              {t("logiTalkLanding.logiTalk")}{" "}
              <span className="text-warning">
                {t("logiTalkLanding.productInfo.howToUseIt.title")}
              </span>
            </p>
            <p
              className="h6 text-white pb-2 mb-4"
              style={{ borderBottom: "1px solid #fff" }}
            >
              {t("logiTalkLanding.productInfo.howToUseIt.description")}
            </p>
          </div>
          <div className="NNS text-white w-100 d-flex flex-column flex-fill">
            <div className="carousel-indicators p-0 m-0 position-static justify-content-start h5 mb-4 font-weight-600">
              <span
                data-target="#productInfoCarousel"
                data-slide-to="0"
                className={`transition-2 ${
                  currentHash === "logiMall"
                    ? "text-warning border-bottom border-warning"
                    : ""
                }  cursor_pointer`}
                onClick={() => setCurrentHash("logiMall")}
              >
                {t("logiTalkLanding.productInfo.howToUseIt.freiscop.menu")}
              </span>
              <span
                className={`transition-2 ${
                  currentHash === "logiWork"
                    ? "text-warning border-bottom border-warning"
                    : ""
                } mx-4  cursor_pointer`}
                data-target="#productInfoCarousel"
                data-slide-to="1"
                onClick={() => setCurrentHash("logiWork")}
              >
                {t("logiTalkLanding.productInfo.howToUseIt.logiwork.menu")}
              </span>
              <span
                className={`transition-2 ${
                  currentHash === "logiKeep"
                    ? "text-warning border-bottom border-warning"
                    : ""
                }   cursor_pointer`}
                data-target="#productInfoCarousel"
                data-slide-to="2"
                onClick={() => setCurrentHash("logiKeep")}
              >
                {t("logiTalkLanding.productInfo.howToUseIt.logikeep.menu")}
              </span>
            </div>
            <div
              id="productInfoCarousel"
              className="carousel slide flex-fill"
              data-touch="false"
              data-interval="false"
            >
              <div className="carousel-inner">
                {howToUseIt.map((item, index) => {
                  return <CarouselItem key={item.key} item={item} />;
                })}
              </div>

              <button
                className="carousel-control-prev bg-transparent border-0 mt-5"
                type="button"
                data-target="#productInfoCarousel"
                data-slide="prev"
                onClick={() => slidePrev()}
              >
                <span className="h1 mb-0">
                  <i className="fa-solid fa-chevron-left" />
                </span>
              </button>
              <button
                className="carousel-control-next bg-transparent border-0 mt-5"
                type="button"
                data-target="#productInfoCarousel"
                data-slide="next"
                onClick={() => slideNext()}
              >
                <span className="h1 mb-0">
                  <i className="fa-solid fa-chevron-right" />
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
